import { BaseDto } from "../base-dto";
import { dinamically_form } from "./dinamically_form";
import { form_item } from "./form_item";

export class dinamically_form_itemDto extends BaseDto {
    public dinamically_FormDto !: dinamically_form;
    public form_items !: form_item[];
} 
